<script setup>
import {onMounted, reactive} from "vue";

const props = defineProps({
    from: {
        type: String,
        required: true,
    },
    to: {
        type: String,
        required: true,
    },
});
let start = new Date(props.from);
let end = new Date(props.to);

</script>

<template v-if="typeof start === 'object' && typeof end === 'object'">
    <time v-if="start.getYear() !== end.getYear()">
        {{ start.toLocaleString('nb-NO', {year:'numeric', month:'2-digit', day:'2-digit'}) }} -
        {{ end.toLocaleString('nb-NO', {year:'numeric', month:'2-digit', day:'2-digit'}) }}
    </time>
    <time v-else-if="start.getMonth() !== end.getMonth()">
        {{ start.toLocaleString('nb-NO', {month:'long', day:'2-digit'}) }} -
        {{ end.toLocaleString('nb-NO', {year:'numeric', month:'long', day:'2-digit'}) }}
    </time>
    <time v-else-if="start.getDay() === end.getDay()">
        {{ end.toLocaleString('nb-NO', {year:'numeric', month:'long', day:'2-digit'}) }}
    </time>
    <time v-else>
        {{ start.toLocaleString('nb-NO', {day:'2-digit'}) }} -
        {{ end.toLocaleString('nb-NO', {year:'numeric', month:'long', day:'2-digit'}) }}
    </time>
</template>
